import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { PersonOutlineOutlined } from '@mui/icons-material';

export type UserImageProps = {
  imageUrl?: string;
  maxWidth?: string;
  borderRadius?: string;
};

export const UserImage: React.FC<UserImageProps> = ({ imageUrl, maxWidth = '80px', borderRadius }) => {
  const { classes, cx } = useUserImageStyles({ maxWidth, borderRadius });

  if (imageUrl) {
    return <img src={imageUrl} className={classes.image} alt="User" />;
  }

  return (
    (
      <div className={cx(classes.image, classes.placeholder)}>
        <PersonOutlineOutlined fontSize="large" />
      </div>
    )
  );
};


type StyleProps = {
  maxWidth: string;
  borderRadius?: string;
};

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
const useUserImageStyles = makeStyles<StyleProps>({ name: 'UserImage' })((theme, { maxWidth, borderRadius }) => ({
  image: {
    width: '100%',
    maxWidth: maxWidth,
    height: 'auto',
    objectFit: 'contain',
    borderRadius: borderRadius,
    overflow: 'hidden',
  },
  placeholder: {
    background: theme.palette.grey[400],
    display: 'grid',
    placeItems: 'center',
    aspectRatio: '1/1',
    color: theme.palette.grey[600],
  }
}));
